"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchButton = exports.SearchInput = exports.StyledIcon = exports.InputWrapper = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("../../Buttons/Button"));

var _Icon = _interopRequireDefault(require("../../IconicDisplayElements/Icon"));

var _helperFunctions = require("../../../styles/helperFunctions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _styledComponents.default.form.withConfig({
  displayName: "SearchBarstyles__Wrapper",
  componentId: "sc-2sk3q4-0"
})(["align-content:flex-start;align-items:center;display:flex;flex-direction:column;position:relative;width:100%;@media only screen and (min-width:", "){flex-direction:row;width:auto;}"], function (props) {
  return props.theme.smallBreak;
});

exports.Wrapper = Wrapper;

var InputWrapper = _styledComponents.default.div.withConfig({
  displayName: "SearchBarstyles__InputWrapper",
  componentId: "sc-2sk3q4-1"
})(["position:relative;width:100%;"]);

exports.InputWrapper = InputWrapper;
var StyledIcon = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "SearchBarstyles__StyledIcon",
  componentId: "sc-2sk3q4-2"
})(["position:absolute;left:", ";top:1.5rem;"], function (props) {
  return (0, _helperFunctions.joinDimensions)('+', props.theme.standardPadding, '.5rem');
});
exports.StyledIcon = StyledIcon;

var SearchInput = _styledComponents.default.input.withConfig({
  displayName: "SearchBarstyles__SearchInput",
  componentId: "sc-2sk3q4-3"
})(["border-radius:1.5rem;border:", ";display:inline-block;height:3rem;line-height:1.1875rem;outline:none;padding-left:", ";padding-right:", ";position:relative;width:100%;margin:", "  ", "  ", "  0;&:focus{border-color:", ";}@media only screen and (min-width:", "){width:", ";}"], function (props) {
  return "".concat(props.theme.standardButtonBorder, " ").concat(props.theme.c_foreground_search_border);
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('+', props.theme.standardPadding, '3rem');
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.c_foreground_primary;
}, function (props) {
  return props.theme.smallBreak;
}, function (props) {
  return props.theme.component_medium;
});

exports.SearchInput = SearchInput;
var SearchButton = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "SearchBarstyles__SearchButton",
  componentId: "sc-2sk3q4-4"
})(["margin-bottom:", ";width:100%;@media only screen and (min-width:", "){margin-bottom:", ";width:inherit;}"], function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 2, props.theme.standardPadding);
}, function (props) {
  return props.theme.smallBreak;
}, function (props) {
  return props.theme.standardPadding;
});
exports.SearchButton = SearchButton;